import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { find, isString } from 'lodash';
import BasicSelect from '../../../../../shared/components/formComponents/groups/BasicSelect';
import { VerbRichTextEditor } from '../../../../../shared/components/formComponents/VerbRichTextEditor';
import RichTextNotesHeader from './RichTextNotesHeader';
import CopyAssetLink from '../../../../components/CopyAssetLink';

const abFormatter = (c) => c && c.join(',');
const abParser = (c) => (c && c.length > 0 && isString(c) ? c.split(',') : []);

class ThisOrThatPermutationResultChartSectionItem extends Component {
    static propTypes = {
        memberReference: PropTypes.string,
        permutationQuestionDataSource: PropTypes.array,
        assetLinkOptions: PropTypes.array,
        contentValues: PropTypes.object,
        isGlobalSectionItem: PropTypes.bool
    };

    getABcategories = () => {
        const { contentValues, permutationQuestionDataSource } = this.props;
        if (!contentValues.questionSectionItemId || !permutationQuestionDataSource.length) {
            return null;
        }
        return find(permutationQuestionDataSource, { id: contentValues.questionSectionItemId }).content.categories;
    };

    render() {
        const { memberReference, permutationQuestionDataSource, isGlobalSectionItem } = this.props;
        const categories = this.getABcategories();
        return (
            <div>
                <div className={'row'}>
                    <Field
                        name={memberReference ? `${memberReference}.content.description` : 'content.description'}
                        label={'Description'}
                        className={'col-7'}
                        placeholder={'Enter a description'}
                        component={VerbRichTextEditor}
                        readOnly={isGlobalSectionItem}
                        rows={3}
                    />
                    <div className={'col-5'}>
                        <RichTextNotesHeader />
                        <CopyAssetLink assetLinkOptions={this.props.assetLinkOptions} />
                    </div>
                </div>
                <div className={'row'}>
                    <Field
                        name={
                            memberReference
                                ? `${memberReference}.content.questionSectionItemId`
                                : 'content.questionSectionItemId'
                        }
                        label={'Referenced A|B Question'}
                        options={permutationQuestionDataSource}
                        className={'col-6'}
                        valueKey={'id'}
                        labelKey={'name'}
                        component={BasicSelect}
                        disabled={isGlobalSectionItem}
                    />
                </div>
                <div className={'row'}>
                    <Field
                        name={
                            memberReference
                                ? `${memberReference}.content.ignoredCategories`
                                : 'content.ignoredCategories'
                        }
                        label={'Categories to Ignore'}
                        className={'col-6'}
                        options={categories}
                        format={abFormatter}
                        parse={abParser}
                        disabled={isGlobalSectionItem}
                        isClearable={true}
                        isMulti={true}
                        valueKey={'id'}
                        labelKey={'name'}
                        component={BasicSelect}
                    />
                </div>
                <RichTextNotesHeader />
                <CopyAssetLink assetLinkOptions={this.props.assetLinkOptions} />
            </div>
        );
    }
}

export default ThisOrThatPermutationResultChartSectionItem;
